<template>
  <path
    d="M6 16C9.314 16 12 14 12 10.5C12 9 11.5 6.5 9.5 4.5C9.75 6 8.25 6.5 8.25 6.5C9 4 7 0.5 4 0C4.357 2 4.5 4 2 6C0.75 7 0 8.729 0 10.5C0 14 2.686 16 6 16ZM6 15C4.343 15 3 14 3 12.25C3 11.5 3.25 10.25 4.25 9.25C4.125 10 5 10.5 5 10.5C4.625 9.25 5.5 7.25 7 7C6.821 8 6.75 9 8 10C8.625 10.5 9 11.364 9 12.25C9 14 7.657 15 6 15Z"
    fill="#F64923"
  />
</template>
